export let DateLocale = /*#__PURE__*/function (DateLocale) {
  DateLocale["en"] = "en-GB";
  // English
  DateLocale["cs"] = "cs-CZ";
  // Čeština
  DateLocale["da"] = "da-DK";
  // Dansk
  DateLocale["de"] = "de-DE";
  // Deutsch
  DateLocale["es"] = "es-ES";
  // Español
  DateLocale["fr"] = "fr-FR";
  // Français
  DateLocale["hi"] = "hi-IN";
  // हिन्दी
  DateLocale["it"] = "it-IT";
  // Italiano
  DateLocale["ja"] = "ja-JP";
  // 日本語
  DateLocale["ko"] = "ko-KR";
  // 한국어
  DateLocale["nl"] = "nl-NL";
  // Nederlands
  DateLocale["id"] = "id-ID";
  // Bahasa Indonesia
  DateLocale["no"] = "no-NO";
  // Norsk
  DateLocale["pl"] = "pl-PL";
  // Polski
  DateLocale["pt"] = "pt-PT";
  // Português
  DateLocale["ru"] = "ru-RU";
  // Русский
  DateLocale["sv"] = "sv-SE";
  // Svenska
  DateLocale["th"] = "th-TH";
  // ไทย
  DateLocale["tr"] = "tr-TR";
  // Türkçe
  DateLocale["uk"] = "uk-UA";
  // Українська
  DateLocale["zh"] = "zh-CN";
  // 繁體中文
  DateLocale["vi"] = "vi-TV"; // Tiếng Việt
  return DateLocale;
}({});
//# sourceMappingURL=locales.js.map